import { render, staticRenderFns } from "./datatransaksi.vue?vue&type=template&id=cf0c429c&scoped=true&"
import script from "./datatransaksi.vue?vue&type=script&lang=js&"
export * from "./datatransaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0c429c",
  null
  
)

export default component.exports